import * as React from 'react'
function SvgWalletFilled(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M24 4H7C5.4 4 4 5.4 4 7s1.4 3 3 3h17V4zM34 14H4v18c0 2.2 1.8 4 4 4h26c1.2 0 2-.8 2-2V16c0-1.2-.8-2-2-2zm-5 14c-1.6 0-3-1.4-3-3s1.4-3 3-3 3 1.4 3 3-1.4 3-3 3z" />
			</g>
		</svg>
	)
}
export default SvgWalletFilled
